module.exports = __webpack_public_path__ + "static/media/loader.c028badc.svg";